<template>
    <div class="demo-beds">
        <SphereNavigation color="orange" selected="demo-beds" />

        <div class="inner-content">
            <h1>{{$t('demo_beds.title')}}</h1>

            <div class="top-actions">
            <DatePicker v-model:date="date" :lockPast="false" color="yellow"/>

            <SearchField v-model:search="searchText" />
        </div>

        <div class="inner-content--list">
            <div class="list">
                <div v-for="appointment in appointmentList" :key="appointment.id" class="list--item yellow" >
                    <div class="list--item--btns">
                        <AppointmentItemSales :appointment="appointment" />

                        {{formatAppointmentTime(appointment)}}

                        <ClientNames :appointment="appointment" />
                    </div>

                    <div class="list--item--btns">
                        <button class="btn-round black btn-result" @click.prevent="selectAppointment(appointment)">
                            <img src="/img/icon-demo-beds-white.svg" />
                        </button>
                    </div>
                </div>
                <div v-if="appointmentList.length == 0 && !loading" class="list--empty">
                    {{$t('appointment_completed.empty')}}
                </div>
            </div>
        </div>

        <Loading v-if="loading" />
        </div>
    </div>
</template>

<script>
import AppointmentItemSales from "@/components/AppointmentItemSales.vue";
import ClientNames from "@/components/ClientNames.vue";
import DatePicker from "@/components/DatePicker.vue";
import Loading from "@/components/app/Loading.vue";
import SphereNavigation from "@/components/app/SphereNavigation.vue";
import SearchField from "@/components/app/SearchField.vue";
import {formatTime, newDateFromString, getDateForPicker} from "@/utils/utils";
import {apiStore} from "@/stores/api";

export default {
    name : "DemoBedAppointmentList",

    components : {
        AppointmentItemSales,
        ClientNames,
        SearchField,
        DatePicker,
        Loading,
        SphereNavigation
    },

    data() {
        return {
            loading : false,
            searchText : "",
            date : getDateForPicker(new Date()),
            appointments: []

        };
    },

    created() {
        this.getAppointmentsForDate();
    },

    computed: {
        appointmentList() {
            const list = this.appointments.filter(x => x.measurement_done || (x.clients.length > 0 && x.clients[0].measurement_result !== null));
            return list.sort((d1, d2) => newDateFromString(d1.date) > newDateFromString(d2.date) ? -1 : 1);
        }
    },

    watch: {
        searchText() {
            if (this.searchText.trim() !== "") {

                this.appointments = apiStore().searchAppointments(this.searchText);

            } else {
                this.getAppointmentsForDate();
            }
        },

        date() {
            this.getAppointmentsForDate();
        }
    },

    methods: {
        selectAppointment(appointment) {
            this.$router.push({name: "demo-beds-detail", params: {appointmentId: appointment.id}});
        },

        formatAppointmentTime(appointment) {
            if (appointment.date !== null) {
                const date = newDateFromString(appointment.date);
                return formatTime(date);
            }
        },

        async getAppointmentsForDate() {
            this.loading = true;

            const requestedDate = this.date;
            const appointments = await apiStore().getAppointments(requestedDate);

            if (requestedDate !== this.date) {
                return;
            }

            this.appointments = appointments;
            this.loading = false;
        }
    }

};
</script>

<style lang="scss" scoped>
    .inner-content {
        &--cols {
            display:flex;
        }

        .top-actions {
            display:flex;
            align-items: center;
            justify-content: space-between;
            height: 3.7rem;
        }

        &--list {

            .list {
                max-height: 55vh;

            }
        }
    }
</style>